/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Quick_Sale_Filter_OnlyInputs */

const vi_order_quick_sale_filter_only = /** @type {(inputs: Order_Quick_Sale_Filter_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ đơn Bán ngay tại quầy`)
};

/**

* @param {Order_Quick_Sale_Filter_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_quick_sale_filter_only = /** @type {((inputs?: Order_Quick_Sale_Filter_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Quick_Sale_Filter_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_quick_sale_filter_only(inputs)
});